import { useFFLDetailClient } from '@/api/backoffice-api';
import AppConfig from '@/utils/app-config.mjs';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Image,
  Spinner,
  useDisclosure
} from '@chakra-ui/react';
import { useParams, useSearchParams } from 'react-router-dom';
import LicenseDetails from '../license-details';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ShowTransferModel } from '@/queue/elements/QueueGrid';

function LicenseDetailsPage({ isSuperAdmin }: { isSuperAdmin: boolean }) {
  const navigate = useNavigate();
  const { first3, last5 } = useParams();
  const [{ loading, error, data }] = useFFLDetailClient({
    baseURL: AppConfig.fflGetApiBaseURL,
    url: `/license/${first3}/${last5}`
  });
  const [queryParams, setQueryParams] = useSearchParams();
  const {
    isOpen: isTransferModalOpen,
    onClose: onCloseTransferModal,
    onOpen: onOpenTransferModal
  } = useDisclosure();
  const showTransferId = queryParams.get('transfer_id');
  useEffect(() => {
    if (window) {
      const transferId = queryParams.get('transfer_id');
      if (transferId) onOpenTransferModal();
    }
  }, [queryParams]);

  const onCloseTransferModalHandler = () => {
    onCloseTransferModal();
    queryParams.delete('transfer_id');
    setQueryParams(queryParams);
  };

  return (
    <Box className={'Explore'}>
      {isTransferModalOpen && (
        <ShowTransferModel
          isOpen={isTransferModalOpen}
          onClose={onCloseTransferModalHandler}
          transfer={{ id: showTransferId as string }}
          reFetchData={() => {}}
          isSuperAdmin={isSuperAdmin}
          isStoreAdmin={false}
          cognitoGroup={false}
        />
      )}
      <Breadcrumb
        spacing="16px"
        separator={
          <Image
            src="/images/ui/right-arrow.svg"
            width="7.41px"
            height="12px"
          />
        }
        padding={0}
      >
        <BreadcrumbItem
          color="#0090C6"
          textDecoration="underline"
          className="breadcrum-item"
          cursor="pointer"
        >
          <span onClick={() => navigate('/dealers')}>Search</span>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
          <span>License Detail</span>
        </BreadcrumbItem>
      </Breadcrumb>
      {!data || loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="85vh"
        >
          <Spinner size="lg" />
        </Box>
      ) : (
        <Box marginTop="32.46px">
          <LicenseDetails data={data[0]} isSuperAdmin={isSuperAdmin} />
        </Box>
      )}
    </Box>
  );
}

export default LicenseDetailsPage;
